import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import CustomTooltip from '../../../../Components/Tooltip/CustomTooltip';

function ImportedDataTableRow({
  item,
  i,
  isSupplierLoggedIn,
  isProductArchived,
  onSelectCheckBox,
  selectedIdArray,
  handleDelete,
  hanldeUpdate,
  bomComponent,
  componentSupplier,
  colourRef,
}) {
  const { t } = useTranslation('common');

  const checkBox = () => {
    return (
      !isSupplierLoggedIn &&
      !isProductArchived && (
        <td>
          <div className="common-checkbox no-label checkbox-center">
            <input
              onChange={(e) => onSelectCheckBox(e, item._id)}
              name={`checking_${i}`}
              id={`checking_${i}`}
              type="checkbox"
              checked={selectedIdArray.filter((val) => val === item._id).length > 0}
            />
            <label htmlFor={`checking_${i}`} className="chklabel" />
          </div>
        </td>
      )
    );
  };

  const showCreatedModifiedBy = () => {
    return (
      <button type="button" aria-label="created modified" className="btn p-0">
        <OverlayTrigger
          placement="bottom"
          trigger="hover"
          rootClose
          overlay={
            <Popover className="custom-popover modified-popover">
              <Popover.Content>
                <div>
                  <p className="m-0 text-left">
                    <strong> {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_TABLE_ROW.CREATED')} </strong> :{' '}
                    {item.createdBy && `${item?.createdBy?.firstName} ${item?.createdBy?.lastName} | `}
                    {moment(item.createdAt).format('DD-MMM-YYYY, h:mm a')}
                  </p>
                  {item?.modifiedBy?.firstName && (
                    <p className="text-left m-0">
                      <strong> {t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_TABLE_ROW.MODIFIED')} </strong> :{' '}
                      {item.modifiedBy && `${item?.modifiedBy?.firstName} ${item?.modifiedBy?.lastName} | `}
                      {moment(item.updatedAt).format('DD-MMM-YYYY, h:mm a')}
                    </p>
                  )}
                </div>
              </Popover.Content>
            </Popover>
          }
        >
          <i className="icon icon-Information f-20" />
        </OverlayTrigger>
      </button>
    );
  };

  const actionButtons = (ele, index) => {
    return (
      <>
        <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_TABLE_ROW.UPDATE')}>
          <button
            type="button"
            aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_TABLE_ROW.UPDATE')}
            className="btn p-0"
            onClick={() => hanldeUpdate(ele, index)}
          >
            <span className="icon icon-Update-1 f-20" />
          </button>
        </CustomTooltip>
        <CustomTooltip tooltipText={t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_TABLE_ROW.DELETE')}>
          <button type="button" className="btn p-0" aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_TABLE_ROW.DELETE')}>
            <span className="icon-Delete f-20" onClick={() => handleDelete(ele._id)} />
          </button>
        </CustomTooltip>
        {showCreatedModifiedBy()}
      </>
    );
  };

  const statuSet = (ele) => {
    switch (ele?.currentStatus) {
      case 'true':
      case 'Approved':
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_TABLE_ROW.APPROVED')}</span>
            <span className="col-status right approved" />
          </>
        );

      case 'false':
      case 'Rejected':
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_TABLE_ROW.REJECT')}</span>
            <span className="col-status right rejected" />
          </>
        );

      default:
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_TABLE_ROW.PENDING')}</span>
            <span className="col-status right pending" />
          </>
        );
    }
  };

  const forSuppliers = () => {
    const supps = [];
    Array.isArray(item?.suppliers) &&
      item?.suppliers?.forEach((ele) => {
        if (ele?.name) {
          supps.push(ele.name);
        }
      });
    return supps.join(' , ');
  };

  const statusCalled = (ele) => {
    return ele?.currentStatus ? (
      statuSet(ele)
    ) : (
      <>
        <span>{t('DEVLOPMENT_ORDER.TESTING.TESTING_REQ_COMPONENT.IMPORTED_TABLE_ROW.PENDING')}</span>
        <span className="col-status right pending" />
      </>
    );
  };

  return (
    <tr key={i}>
      {checkBox()}
      <td className="first-fix-col">
        <div className="document-title">
          <span>
            <a
              href={`${window.location.origin}/development-order/${item._id}/testing/testing-requirements`}
              target="_blank"
              className="text-black"
              rel="noopener noreferrer"
            >
              {item?.number}
            </a>
          </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{item?.description} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{forSuppliers()}</span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{componentSupplier?.name} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{item?.brandId?.name} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{item?.seasonId?.name} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{item?.month} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{item?.year} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{item?.catOneId?.name} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{item?.catTwoId?.name} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{item?.catThreeId?.name} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{item?.catFourId?.name} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{item?.testReport?.pdfTitle} </span>
        </div>
      </td>
      <td>
        <div className="document-title">
          <span>{bomComponent?.referenceCode ? bomComponent?.referenceCode : bomComponent} </span>
        </div>
      </td>
      <td className="last-fix-col">
        <div className="document-title">
          <span>{Array.isArray(colourRef) ? colourRef[0]?.name : item?.colourRef?.name} </span>
        </div>
      </td>
      <td>{statusCalled(item)}</td>
      <td>
        <div className="document-title">
          <span>{item?.isMatch ? 'Yes' : 'No'} </span>
        </div>
      </td>
      <td>
        <div className="table-action-container">{actionButtons(item, i)}</div>
      </td>
    </tr>
  );
}

export default ImportedDataTableRow;
